import getSafe from '../../utils/getSafe';
import {
  CREATE_PAYMENT_PLAN,
  CREATE_PAYMENT_PLAN_REQUEST,
  CREATE_PAYMENT_PLAN_FAILURE,
  CREATE_PAYMENT_PLAN_SUCCESS,
  EXECUTE_PAYMENT_PLAN,
  EXECUTE_PAYMENT_PLAN_FAILURE,
  EXECUTE_PAYMENT_PLAN_SUCCESS,
  EXECUTE_PAYMENT_PLAN_REQUEST,
} from './types';

export const initialState = {
  lastAction: null,
  paymentPlanId: null,
  networkError: null,
  graphqlErrors: [],
  paymentOptions: [],
  selectedAddress: null,
  addresses: [],
  lineItemGroups: [],
  fulfillmentDetails: null,
  executionState: null,
  executePaymentPlanData: {},
  isLoading: false,
};

const parsePaymentPlan = (payload) => {
  // Can be undefined if there is an error
  if (!payload.data) {
    return {};
  }

  return {
    paymentPlanId: payload.data.paymentPlan.id,
    paymentOptions: payload.data.paymentPlan.paymentOptions,
    addresses: payload.data.paymentPlan.addresses,
    selectedAddress: payload.data.paymentPlan.selectedAddress,
    lineItemGroups: payload.data.paymentPlan.lineItemGroups,
    fulfillmentDetails: payload.data.paymentPlan.fulfillmentDetails,
    executionState: payload.data.paymentPlan.executionState,
  };
};

const parseNetworkError = (action) => ({
  status: action.status,
  errors: action.payload.errors,
  message: action.message,
});

const checkoutPaymentReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_PAYMENT_PLAN_REQUEST:
      return {
        ...state,
        lastAction: CREATE_PAYMENT_PLAN,
        isLoading: true,
      };
    // GraphQL response, could include errors
    case CREATE_PAYMENT_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        networkError: null,
        graphqlErrors: action.payload.errors || [],
        ...parsePaymentPlan(action.payload),
      };
    // Network failure, eg, not a 200, could be bad query
    case CREATE_PAYMENT_PLAN_FAILURE:
      return {
        ...state,
        isLoading: false,
        networkError: parseNetworkError(action),
      };
    case EXECUTE_PAYMENT_PLAN_REQUEST:
      return {
        ...state,
        lastAction: EXECUTE_PAYMENT_PLAN,
        isLoading: true,
      };
    case EXECUTE_PAYMENT_PLAN_FAILURE:
      return {
        ...state,
        isLoading: false,
        networkError: parseNetworkError(action),
      };
    case EXECUTE_PAYMENT_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        networkError: null,
        graphqlErrors: getSafe(() => action.payload.errors) || [],
        executePaymentPlanData: getSafe(() => action.payload.data.executePaymentPlan) || {},
      };
    default:
      return state;
  }
};

export default checkoutPaymentReducer;
